import React, { useEffect, useState } from 'react';

import { Banner, Progress, Text } from '@betterment/samba-react';

import { useCoPilotSectionState } from '../../contexts/CoPilotSectionContext';

const FlashSection: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { status, selectedItemsCount, showSuccessBanner, canSendReminders } = useCoPilotSectionState();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (status === 'sendingReminder' && progress < 100) {
      const interval = setInterval(() => setProgress(progress + 20), 200);
      return () => clearInterval(interval);
    }
    if (status === 'loading' || status === 'actionError') {
      setProgress(0);
    }
    // eslint-disable-next-line consistent-return
    return undefined;
  }, [progress, status]);

  if (status === 'actionError') {
    return (
      <Banner variant="critical" css={{ borderRadius: 'none', border: 'none' }}>
        <Banner.Content>
          <Text color="text.critical">Uh oh, something went wrong. Try again.</Text>
        </Banner.Content>
      </Banner>
    );
  }

  if (status === 'sendingReminder') {
    return (
      <>
        <Banner variant="info" css={{ borderRadius: 'none', border: 'none' }}>
          <Banner.Content>
            <Text color="text">Sending emails</Text>
          </Banner.Content>
        </Banner>
        <Progress indicatorColor="background.info.strong" value={progress} />
      </>
    );
  }

  if (showSuccessBanner) {
    return (
      <Banner variant="success" css={{ borderRadius: 'none', border: 'none' }}>
        <Banner.Content>
          <Text color="text">Success. Email reminders have been sent!</Text>
        </Banner.Content>
      </Banner>
    );
  }

  if (selectedItemsCount > 0 && canSendReminders) {
    return (
      <Banner variant="info" css={{ borderRadius: 'none', border: 'none' }}>
        <Banner.Content>
          <Text color="text">
            Ready to send {selectedItemsCount} email reminder
            {selectedItemsCount > 1 ? 's' : ''}
          </Text>
        </Banner.Content>
      </Banner>
    );
  }

  return null;
};

export default FlashSection;
